import { render, staticRenderFns } from "./SanityYouTubeSerializer.vue?vue&type=template&id=b07e74bc&scoped=true&"
import script from "./SanityYouTubeSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityYouTubeSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityYouTubeSerializer.vue?vue&type=style&index=0&id=b07e74bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e74bc",
  null
  
)

export default component.exports